module.exports = "<a href=\"#\" class=\"list-group-item list--item\" id=\"note-{{ id }}\" data-id=\"{{id}}\">\n    <h4 class=\"list-group-item-heading\">\n        <span class=\"list--item--query\">{{ title }}</span>\n        <span class=\"favorite pull-right icon-star-empty\n            <% if (isFavorite === 1) {%>icon-favorite<% } %>\">\n        </span>\n    </h4>\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/fuzzySearch/template.html
// module id = 1198
// module chunks = 0